import { toDataURL } from "../../../utilities/imageUtilities";

export async function getPDFHeader(title, district, school) {
  var columns = [];

  var img = await toDataURL(require("../../../assets/nctwcs/logo.png"));

  columns.push({
    width: 60,
    image: img,
  });

  columns.push({
    margin: [40, 0, 0, 0],
    stack: [
      { text: title, style: "header" },
      {
        text: [
          { text: `District:`, bold: true },
          ` ${district ? district.name : "All Districts"}`,
        ],
        style: "subTitle",
      },
      {
        text: [
          { text: `School:`, bold: true },
          ` ${school ? school.name : "All Schools"}`,
        ],
        style: "subTitle",
      },
    ],
  });

  return {
    columns,
    margin: [0, 0, 20, 0],
  };
}
